const NO_CATEGORY_LABEL = 'Aucune catégorie';

// The tooltip of a third party avatar: its name, with its categories in the
// context it is shown in; the name alone out of a context.
export const thirdPartyTooltipOf = (
  name: string,
  categoriesLabel?: string,
): string =>
  categoriesLabel === undefined
    ? name
    : `${name} : ${categoriesLabel || NO_CATEGORY_LABEL}`;
